import { LineItem } from '@wix/ambassador-premium-store/rpc';
import { AppParams } from 'types';
import { PaymentCycle } from 'enums';
import { OrderPageDataResponse } from 'checkout-dto-types';

export interface OrderPageDataRequest {
  productId: number;
  paymentCycle: PaymentCycle;
  siteGuid: string;
  couponCode?: string;
  existingUserPacakgeGuid?: string;
  oldSiteGuid?: string;
}

export interface DynamicOrderPageDataRequest {
  eventAggregator: string;
  cartItems: LineItem[];
}

export type FetchOrderPageData = (
  request: any,
) => Promise<OrderPageDataResponse>;

export enum DoublePurchaseValidationResult {
  GENERAL_ERROR = -800,
  PENDING = -801,
  ALREADY_DELIVERED = -802,
}

export enum DynamicDoublePurchaseValidationResult {
  OK = 'OK',
  PENDING = 'PENDING',
  DELIVERED = 'DELIVERED',
  SERVER_ERROR = 'SERVER_ERROR',
}

export interface DoublePurchaseRequest {
  siteGuid: AppParams['siteGuid'];
  appDefId: number;
  eventAggregator: AppParams['eventAggregator'];
  paymentCycle: PaymentCycle;
  productId: number;
  upgrade: boolean;
}
export interface DynamicDoublePurchaseRequest {
  siteGuid: AppParams['siteGuid'];
}

export interface DoublePurchaseResponse {
  success: boolean;
  validationCode: DoublePurchaseValidationResult;
  existingPackageInfo: {
    planName: string;
    cycle: PaymentCycle;
    conflictingServiceGuid: string;
  } | null; // if server cannot check in SBS for duplicate package returns null
}
export interface DynamicDoublePurchaseResponse {
  status: DynamicDoublePurchaseValidationResult;
}
